import { AxiosResponse } from 'axios';

import { API_URL } from '../../utils/constants';
import request from '../request';

export default {
  changeStatus: async (status, id: string) => {
    const body = JSON.stringify(status);
    return request(`${API_URL}/orders/change-consolidation-status/${id}`, 'put', body);
  },
};
